import { LinkButton, UIHeading1, UIHeading2, Image, useDeviceType } from '@cian/ui-kit';
import { Ticker } from '@cian/adfox-templates';
import * as React from 'react';
import type { JSX } from 'react';

import { AdLabel } from '../../../AdLabel';
import { Marquee } from '../../../Marquee';

import * as styles from './Slide.css';

interface ICarouselBannerProps {
  active: boolean;
  sliderControlsView: JSX.Element | null | false;
  /** Рекламный дисклеймер **/
  disclaimer?: string | null;
  /** Изображение баннера **/
  imageUrl: string;
  /** Подзаголовок **/
  subtitle: string;
  /** Надпись на кнопке баннера **/
  textButton: string;
  /** Заголовок **/
  title: string;
  /** URL перехода с баннера **/
  urlLink: string;
}

export const Slide: React.FC<ICarouselBannerProps> = props => {
  const { sliderControlsView, imageUrl, title, subtitle, urlLink, textButton, disclaimer, active } = props;

  const deviceType = useDeviceType();

  return (
    <div className={styles['slide']} data-testid="main-carousel-slide" data-active={active ? '' : undefined}>
      <div className={styles['slide__image-wrapper']}>
        <Image data-testid="image" src={imageUrl} alt={title} width="100%" height="100%" objectFit="cover" />
      </div>

      <div className={styles['information-container']}>
        <div className={styles['title']}>
          <UIHeading1 data-testid="title" color="text-inverted-default">
            {title}
          </UIHeading1>
        </div>
        <div className={styles['subtitle']}>
          <UIHeading2 data-testid="subtitle" color="text-inverted-default">
            {subtitle}
          </UIHeading2>
        </div>
        <div className={styles['button']}>
          <LinkButton
            data-testid="button"
            rel="noopener noreferrer"
            target="_blank"
            href={urlLink}
            theme="fill_white_primary"
          >
            {textButton}
          </LinkButton>
          {sliderControlsView}
        </div>
        <div data-testid="disclaimer" className={styles['disclaimer']}>
          {(() => {
            if (!disclaimer) {
              return null;
            }

            if (deviceType === 'desktop') {
              return <Marquee text={disclaimer} />;
            }

            if (!active) {
              return <span className={styles['disclaimer--inactive-text']}>{disclaimer}</span>;
            }

            return <Ticker theme="light" text={disclaimer} />;
          })()}
        </div>
      </div>
      <div className={styles['label']}>
        <AdLabel />
      </div>
    </div>
  );
};
